<template>
  <img v-if="url" :src="url" />
</template>

<script>
import { Firebase } from "@/services/firebase";

export default {
  props: {
    path: String,
  },

  data() {
    return {
      url: "",
    };
  },

  async mounted() {
    if (!this.path) {
      return;
    }
    let storage = Firebase.storage();
    let storageRef = storage.ref();
    this.url = await storageRef.child(this.path).getDownloadURL();
  },
};
</script>